import { useEffect, useContext, useState } from "react";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import ChartsHandler from "../../../../components/Charts/ChartsHandler.tsx";
import "./QuartoDashboard.css";
import DadosUsuarioRedux from "../../../../contexts/Usuario.js";
import { Card } from "primereact/card";
import CoresRedux from "../../../../contexts/Cor.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario.js";
import { useLocation, useNavigate } from "react-router-dom";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao.js";
import { getRegras } from "../../../../services/ModuloGerenciador/Geral.ts";
import { getDashboard3 } from "../../../../services/ModuloGerenciador/Dashboard.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import { motion } from "framer-motion";
import { getDashEmbarque3Search } from "../../../../services/ModuloGerenciador/Search.js";
import FiltrosRedux from "../../../../contexts/Filtros.js";
import iconeImprimir from "../../../../images/iconeImprimir.png";
import iconeAnterior from "../../../../images/iconeAnterior.png";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2.js";
import iconeProximo from "../../../../images/iconeProximo.png";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";

function TerceiroDashboad() {
  const { dadosUsuarioRedux, setDadosUsuarioRedux } =
    useContext(DadosUsuarioRedux);

  const { multiplosFiltrosRedux, setMultiplosFiltrosRedux } = useContext(
    MultiplosFiltrosRedux
  );

  const { filtrosRedux, setFiltrosRedux } = useContext(FiltrosRedux);

  const [values, setValues] = useState({});

  const [openToastSucesso, setOpenToastSucesso] = useState(false);

  const [textoSucesso, setTextoSucesso] = useState("");

  const [openToastErro, setOpenToastErro] = useState(false);

  const [textoErro, setTextoErro] = useState("");

  const [dadosFaturamentoMotorista, setDadosFaturamentoMotorista] = useState(
    []
  );

  const [dadosFaturamentoContexto, setDadosFaturamentoContexto] = useState([]);

  const [dadosFaturamentoUnidade, setDadosFaturamentoUnidade] = useState([]);

  const [dadosFaturamentoEmpresa, setDadosFaturamentoEmpresa] = useState([]);

  const [dadosFaturamentoFilial, setDadosFaturamentoFilial] = useState([]);

  const [dadosFaturamentoVeiculo, setDadosFaturamentoVeiculo] = useState([]);

  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const handleCloseToastSucesso = (value) => {
    setOpenToastSucesso(false);
  };

  const handleCloseToastErro = (value) => {
    setOpenToastErro(false);
  };

  useEffect(() => {
    verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
    const contextoDash = "todos";
    var date = new Date();
    var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
    var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    setValues({
      contexto: contextoDash,
      dataInicio: primeiroDia,
      dataFinal: ultimoDia,
    });
  }, []);

  const imprimir = () => {
    window.print();
  };

  const voltarPage = () => {
    navigate("/terceiro-dashboard");
    localStorage.setItem("flagPaginando", "true");
  };

  const proxPage = () => {
    navigate("/quinto-dashboard");
    localStorage.setItem("flagPaginando", "true");
  };

  const [semAutorizacao, setSemAutorizacao] = useState(true);

  useEffect(() => {
    if (dadosUsuarioRedux.regras !== undefined) {
      dadosUsuarioRedux.regras.forEach((element) => {
        if (element === "Dashboard") {
          setSemAutorizacao(false);
        }
      });
    } else {
      verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
      getRegras(
        dadosUsuarioRedux.token,
        dadosUsuarioRedux.usuario.idUsuario
      ).then((result) => {
        let regras = [];
        result.data.forEach((dado) => {
          regras.push(dado.regras.regra);
          if (dado.regras.regra === "Dashboard") {
            setSemAutorizacao(false);
          }
        });
        dadosUsuarioRedux.regras = regras;
        setDadosUsuarioRedux(dadosUsuarioRedux);
      });
    }
  });

  const itensFiltro = [
    {
      nomeColuna: "Tipo Carroceria",
      field: "tipoCarroceria",
    },
    {
      nomeColuna: "Descrição",
      field: "descricao",
    },
    {
      nomeColuna: "Empresa",
      field: "empresa",
    },
    {
      nomeColuna: "Filial",
      field: "filial",
    },
    {
      nomeColuna: "Unidade de Embarque",
      field: "unidEmbarque",
    },
    {
      nomeColuna: "Cidade Origem",
      field: "cidadeOrigem",
    },
    {
      nomeColuna: "Estado Origem",
      field: "estadoOrigem",
    },
    {
      nomeColuna: "Cidade Destino",
      field: "cidadeDestino",
    },
    {
      nomeColuna: "Estado Destino",
      field: "estadoDestino",
    },
    {
      nomeColuna: "Pedido",
      field: "pedido",
    },
    {
      nomeColuna: "CTE",
      field: "cte",
    },
    {
      nomeColuna: "Previsão Viagem",
      field: "previsaoEmbarque",
    },
    {
      nomeColuna: "Data Viagem",
      field: "dataEmbarque",
    },
    {
      nomeColuna: "Previsão Entrega",
      field: "previsaoEntrega",
    },
    {
      nomeColuna: "Data Entrega",
      field: "dataEntrega",
    },
    {
      nomeColuna: "Data Hora Chegada Viagem",
      field: "dataHoraChegadaEmbarque",
    },
    {
      nomeColuna: "Data Hora Chegada Entrega",
      field: "dataHoraChegadaEntrega",
    },
    {
      nomeColuna: "Data Hora Entregue",
      field: "dataHoraEntregue",
    },
    {
      nomeColuna: "Data Hora Embarcado",
      field: "dataHoraEmbarcado",
    },
    {
      nomeColuna: "Aceite",
      field: "aceite",
    },
    {
      nomeColuna: "Status",
      field: "status",
    },
    {
      nomeColuna: "Placa Cavalo",
      field: "placaCavalo",
    },
    {
      nomeColuna: "Placa Carreta",
      field: "placaCarreta",
    },
    {
      nomeColuna: "Placa Segunda Carreta",
      field: "placaCarreta2",
    },
    {
      nomeColuna: "Proprietario",
      field: "proprietario",
    },
    {
      nomeColuna: "Motorista",
      field: "veiculoMotorista",
    },
    {
      nomeColuna: "ICMS",
      field: "icms",
    },
    {
      nomeColuna: "Frete Motorista",
      field: "freteMotorista",
      tipo: "number",
    },
    {
      nomeColuna: "Frete Fiscal",
      field: "freteFiscal",
      tipo: "number",
    },
    {
      nomeColuna: "Adicional Empresa",
      field: "adicionalEmpresa",
      tipo: "number",
    },
    {
      nomeColuna: "Adicional Motorista",
      field: "adicionalMotorista",
      tipo: "number",
    },
    {
      nomeColuna: "Pedagio",
      field: "pedagio",
      tipo: "number",
    },
    {
      nomeColuna: "Classificação",
      field: "classificacao",
      tipo: "number",
    },
    {
      nomeColuna: "Margem",
      field: "margem",
    },
    {
      nomeColuna: "Adiantamento",
      field: "adiantamento",
      tipo: "number",
    },
    {
      nomeColuna: "Saldo",
      field: "saldo",
      tipo: "number",
    },
    {
      nomeColuna: "Meio Pagamento",
      field: "meioPagamento",
    },
    {
      nomeColuna: "Meio Pagamento Dois",
      field: "meioPagamento2",
    },
    {
      nomeColuna: "Km",
      field: "km",
      tipo: "number",
    },
    {
      nomeColuna: "Cliente",
      field: "cliente",
    },
    {
      nomeColuna: "Embarcador",
      field: "embarcador",
    },
    {
      nomeColuna: "Destinatario",
      field: "destinatario",
    },
    {
      nomeColuna: "LOAD",
      field: "load",
    },
    {
      nomeColuna: "Mercadoria",
      field: "mercadoria",
    },
    {
      nomeColuna: "Peso",
      field: "peso",
      tipo: "number",
    },
    {
      nomeColuna: "Embalagem",
      field: "embalagem",
    },
    {
      nomeColuna: "Observação",
      field: "observacao",
    },
    {
      nomeColuna: "Frota",
      field: "frota",
    },
    {
      nomeColuna: "Cancelado",
      field: "cancelado",
    },
    {
      nomeColuna: "Motivo",
      field: "motivo",
    },
  ];

  const [valuesPesquisa, setValuesPesquisa] = useState([]);

  const limpar = () => {
    setLoading(true);
    setValuesPesquisa([]);
    buscarSearchReset();
  };

  const buscarSearch = async () => {
    setLoading(true);
    let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
    if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
      for (let filtro of multiplosFiltrosRedux) {
        pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
      }
    }
    await getDashEmbarque3Search(
      dadosUsuarioRedux.token,
      pesquisaFormatada,
      valuesPesquisa.contexto,
      valuesPesquisa.embarqueInicio,
      valuesPesquisa.embarqueFinal
    )
      .then((result) => {
        setDadosFaturamentoContexto(result.data.grafico1.barra);
        setDadosFaturamentoEmpresa(result.data.grafico2.barra);
        setDadosFaturamentoUnidade(result.data.grafico3.barra);
        setDadosFaturamentoFilial(result.data.grafico4.barra);
        setDadosFaturamentoVeiculo(result.data.grafico5.barra);
        setDadosFaturamentoMotorista(result.data.grafico6.barra);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response?.data?.length > 200) {
          setTextoErro(
            "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
          );
        } else {
          setTextoErro(error.response.data);
        }
        setOpenToastErro(true);
        setLoading(false);
      });
  };

  const buscarSearchReset = async () => {
    setLoading(true);
    const pesquisaFormatada = "undefined=undefined";
    await getDashEmbarque3Search(
      dadosUsuarioRedux.token,
      pesquisaFormatada,
      valuesPesquisa.contexto,
      valuesPesquisa.embarqueInicio,
      valuesPesquisa.embarqueFinal
    )
      .then((result) => {
        setDadosFaturamentoContexto(result.data.grafico1.barra);
        setDadosFaturamentoEmpresa(result.data.grafico2.barra);
        setDadosFaturamentoUnidade(result.data.grafico3.barra);
        setDadosFaturamentoFilial(result.data.grafico4.barra);
        setDadosFaturamentoVeiculo(result.data.grafico5.barra);
        setDadosFaturamentoMotorista(result.data.grafico6.barra);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response?.data?.length > 200) {
          setTextoErro(
            "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
          );
        } else {
          setTextoErro(error.response.data);
        }
        setOpenToastErro(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (valuesPesquisa.contexto !== undefined) {
      buscarSearch();
    }
  }, [valuesPesquisa.contexto]);

  const location = useLocation();

  useEffect(() => {
    setValuesPesquisa((current) => ({
      ...current,
      item: undefined,
      pesquisa: undefined,
    }));
    setFiltrosRedux((current) => ({
      ...current,
      item: undefined,
      pesquisa: undefined,
    }));
  }, [location.pathname]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {semAutorizacao ? (
        <>
          <NavbarV3 title="Faturamento" selecionado="Dashboard" />
          <SemAutorizacao></SemAutorizacao>
        </>
      ) : (
        <div>
          <NavbarV3 title="Faturamento" selecionado="Dashboard" />
          <div className="dashboards">
            <div className="header-dashboard1">
              <div className="flex2">
                <p className="indicador-principal-faturamento-v2"></p>
                <img
                  onClick={imprimir}
                  className="imagens-faturamentos"
                  src={iconeImprimir}
                />
              </div>
            </div>
            <div className="containerBuscas1">
              <div className="filtro-embarque">
                {
                  <FiltroV2
                    classe="div-filtrar-faturamento-v2"
                    classOption="select-options"
                    itensFiltro={itensFiltro}
                    valuesPesquisa={valuesPesquisa}
                    setValuesPesquisa={setValuesPesquisa}
                    buscarSearch={buscarSearch}
                    limpar={limpar}
                  />
                }
              </div>
              <div>
                <img
                  onClick={voltarPage}
                  className="imagens-faturamentos"
                  src={iconeAnterior}
                />
                <img
                  onClick={proxPage}
                  className="imagens-faturamentos"
                  src={iconeProximo}
                />
              </div>
            </div>
            <div className="charts">
              {!loading ? (
                <div>
                  <div className="graficosCima">
                    <div className="item">
                      <Card>
                        <ChartsHandler
                          data={dadosFaturamentoContexto}
                          type={"bar"}
                          height="auto"
                          width={570}
                          title={"Embarque Prazo"}
                        />
                      </Card>
                    </div>
                    <div className="item">
                      <Card>
                        <ChartsHandler
                          data={dadosFaturamentoEmpresa}
                          type={"bar"}
                          height="auto"
                          width={570}
                          title={"Entrega Prazo"}
                        />
                      </Card>
                    </div>
                    <div className="item">
                      <Card>
                        <ChartsHandler
                          data={dadosFaturamentoUnidade}
                          type={"bar"}
                          height="auto"
                          width={570}
                          title={"Todos Prazos"}
                        />
                      </Card>
                    </div>
                    <div className="item">
                      <Card>
                        <ChartsHandler
                          data={dadosFaturamentoFilial}
                          type={"bar"}
                          height="auto"
                          width={570}
                          title={"Estado Origem"}
                        />
                      </Card>
                    </div>
                    <div className="item">
                      <Card>
                        <ChartsHandler
                          data={dadosFaturamentoVeiculo}
                          type={"bar"}
                          height="auto"
                          width={570}
                          title={"Estado Destino"}
                        />
                      </Card>
                    </div>
                    <div className="item">
                      <Card>
                        <ChartsHandler
                          data={dadosFaturamentoMotorista}
                          type={"bar"}
                          height="auto"
                          width={570}
                          title={"Embarque Por Filial"}
                        />
                      </Card>
                    </div>
                  </div>
                  <br></br>
                  <br></br>
                </div>
              ) : (
                <LoadingComponent />
              )}
            </div>
          </div>
          <ToastSucesso
            texto={textoSucesso}
            open={openToastSucesso}
            onClose={handleCloseToastSucesso}
          />
          <ToastErro
            texto={textoErro}
            open={openToastErro}
            onClose={handleCloseToastErro}
          />
        </div>
      )}
    </motion.div>
  );
}

export default TerceiroDashboad;
